import React from 'react';
import PropTypes from 'prop-types';

import { LogoStyled } from './Logo.styled';

import {
  LogoDefaultVersion,
  LogoBrandedVersion,
  LogoBrandNameVersion,
  LogoBoxVersion,
  LogoAppVersion,
  LogoMadeOnVersion,
} from './Logo.versions';

export const logoVariant = {
  APP: 'app',
  BOX: 'box',
  BRANDNAME: 'brandName',
  DEFAULT: 'default',
  BRANDED: 'branded',
  MADEON: 'madeon',
};

export default function Logo({
  className,
  size,
  label,
  variant,
  negativeVersion,
}) {
  // LogoDefaultVersion.label === 'wf' ? '0 0 105 42' : '0 0 55.8 40.1';
  return (
    <LogoStyled
      xmlns='http://www.w3.org/2000/svg'
      viewBox={
        variant === logoVariant.BRANDNAME
          ? LogoBrandNameVersion.viewBox
          : variant === logoVariant.APP
          ? LogoAppVersion.viewBox
          : variant === logoVariant.BOX
          ? LogoBoxVersion.viewBox
          : variant === logoVariant.MADEON
          ? LogoMadeOnVersion.viewBox
          : variant === logoVariant.BRANDED
          ? LogoBrandedVersion.viewBox
          : LogoDefaultVersion.viewBox
      }
      className={className}
      role='img'
      size={size}
      aria-label='Wikifactory Logo'
      label={label}
      variant={variant}
      negativeVersion={negativeVersion}
    >
      {variant === logoVariant.BRANDNAME ? (
        <LogoBrandNameVersion />
      ) : variant === logoVariant.APP ? (
        <LogoAppVersion negativeVersion={negativeVersion} />
      ) : variant === logoVariant.BOX ? (
        <LogoBoxVersion negativeVersion={negativeVersion} />
      ) : variant === logoVariant.MADEON ? (
        <LogoMadeOnVersion negativeVersion={negativeVersion} />
      ) : variant === logoVariant.BRANDED ? (
        <LogoBrandedVersion label={label} />
      ) : (
        <LogoDefaultVersion />
      )}
    </LogoStyled>
  );
}

Logo.defaultProps = {
  size: '100px',
  variant: logoVariant.DEFAULT,
  negativeVersion: false,
};

Logo.propTypes = {
  className: PropTypes.string,
  /**
   * This prop provides a custom size to the logo with brandname or without
   */
  size: PropTypes.string,
  /**
   * This prop shows a label brand close to the logo, valid for building the wikifactory community, workspace, marketplace branded variant.
   */
  label: PropTypes.string,
  /**
   * Defines different visual appearances for the component.
   */
  variant: PropTypes.oneOf(Object.values(logoVariant)),
  /**
   * This prop shows the negative version of every logo's variant
   */
  negativeVersion: PropTypes.bool,
};
